import { useMemo, useState } from 'react'
import { Col, Form, Modal, Row, Table } from 'react-bootstrap'
import { Check2Square, CheckAll, Search } from 'react-bootstrap-icons'
import { useOrdenation } from '../../hooks/useOrdenation'
import ProdutosService from '../../services/database/ProdutosService'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import { Center } from '../Center'
import { CustomButton } from '../CustomButton'
import { CustomSpinner } from '../CustomSpinner'

export function ModalProdutos({ isOpen, onClose, onSelectProducts }) {
  const [produtos, setProdutos] = useState([])
  const [selectedProdutos, setSelectedProdutos] = useState([])
  const [isProdutosLoading, setIsProdutosLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [searchFilter, setSearchFilter] = useState('')

  const filteredProducts = useMemo(() => {
    let data = produtos

    if (searchFilter) {
      data = data.filter((product) =>
        String(product.DESCRICAO)
          .toLowerCase()
          .includes(searchFilter.toLowerCase()),
      )
    }

    return data
  }, [produtos, searchFilter])

  const { filteredItems, Th, Paginate } = useOrdenation(
    filteredProducts,
    'SKU',
    'asc',
  )

  function selectAllProducts(data) {
    for (const product of data) {
      setSelectedProdutos((prevState) => {
        if (!prevState.includes(product)) {
          return [...prevState, product]
        }

        return prevState
      })
    }
  }

  async function handleSearch() {
    try {
      setIsProdutosLoading(true)

      const data = await ProdutosService.getAll(search)

      setProdutos(Array.isArray(data) ? data : [data])
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar os funcionários')
    } finally {
      setIsProdutosLoading(false)
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Produtos</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col>
            <Form.Label>SKU ou Descrição</Form.Label>
            <Form.Control
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Digite aqui..."
              onKeyDown={(e) => {
                if (e.key === 'Enter' && search) {
                  handleSearch()
                }
              }}
            />
          </Col>

          <Col xs={2}>
            <div
              style={{
                height: '100%',
                display: 'flex',
                alignItems: 'flex-end',
              }}
            >
              <CustomButton
                title="Pesquisar"
                onClick={handleSearch}
                isLoading={isProdutosLoading}
                isLoadingText="Pesquisando..."
                isDisabled={!search}
              >
                <Search />
              </CustomButton>
            </div>
          </Col>
        </Row>

        <Row className="mt-3 mb-3">
          <Col>
            <Form.Label>Filtrar</Form.Label>
            <Form.Control
              value={searchFilter}
              onChange={(e) => setSearchFilter(e.target.value)}
              placeholder="Digite aqui..."
            />
          </Col>
        </Row>

        {isProdutosLoading ? (
          <Center column>
            <CustomSpinner size={30} />
            <p>Carregando...</p>
          </Center>
        ) : (
          <>
            {filteredItems.length > 0 && (
              <>
                <Table
                  hover
                  striped
                  bordered
                >
                  <thead>
                    <tr>
                      <th
                        scope="row"
                        colspan="12"
                      >
                        <section
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <article>
                            <CustomButton
                              noMargin
                              title="Selecionar/Desmarcar Todos"
                              onClick={() => {
                                if (selectedProdutos.length > 0) {
                                  setSelectedProdutos([])
                                } else {
                                  selectAllProducts(filteredProducts)
                                }
                              }}
                            >
                              <Check2Square />
                            </CustomButton>
                          </article>

                          <strong>
                            {selectedProdutos.length} selecionados
                          </strong>
                        </section>
                      </th>
                    </tr>

                    <tr>
                      <th>
                        <Form.Check
                          checked={
                            filteredItems.length > 0 &&
                            filteredItems.every((product) =>
                              selectedProdutos.includes(product),
                            )
                          }
                          disabled={filteredItems.length === 0}
                          onChange={(e) => {
                            if (e.target.checked) {
                              selectAllProducts(filteredItems)
                            } else {
                              for (const product of filteredItems) {
                                setSelectedProdutos((prevState) =>
                                  prevState.filter(
                                    (prod) => prod.SKU !== product.SKU,
                                  ),
                                )
                              }
                            }
                          }}
                        />
                      </th>

                      <Th
                        label="SKU"
                        value="SKU"
                      />
                      <Th
                        label="Descrição"
                        value="DESCRICAO"
                      />
                    </tr>
                  </thead>

                  <tbody>
                    {filteredItems.map((produto) => (
                      <tr>
                        <td>
                          <Form.Check
                            checked={
                              selectedProdutos.findIndex(
                                (prod) => prod.SKU === produto.SKU,
                              ) === -1
                                ? false
                                : true
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedProdutos((prevState) => [
                                  ...prevState,
                                  produto,
                                ])
                              } else {
                                setSelectedProdutos((prevState) =>
                                  prevState.filter(
                                    (prod) => prod.SKU !== produto.SKU,
                                  ),
                                )
                              }
                            }}
                          />
                        </td>
                        <td>{produto.SKU}</td>
                        <td>{produto.DESCRICAO}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Paginate />
              </>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Selecionar"
          isDisabled={selectedProdutos.length === 0}
          onClick={() => {
            onSelectProducts(selectedProdutos)
            onClose()
          }}
        >
          <CheckAll size={22} />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
